import React from 'react';

export default function IcUpload() {
  return (
    <svg width="138" height="106" viewBox="0 0 138 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M68.9997 0C89.9858 0 107.236 17.2185 111.261 40.0732C126.32 41.0893 138.063 55.494 137.999 72.875C137.999 91.0921 125.061 106 109.25 106H34.4999C15.5221 106 0 88.1093 0 66.25C0 45.7028 13.511 28.8107 30.761 26.8232C37.9499 10.9296 52.3248 0 68.9997 0ZM78.6771 81V59.9476L89.49 59.9565C92.9298 59.9593 94.7687 55.9066 92.5013 53.3198L72.4384 30.4309C70.8453 28.6134 68.0166 28.613 66.423 30.4302L46.3581 53.3102C44.0908 55.8956 45.9268 59.9476 49.3655 59.9476H60.1851V81C60.1851 83.2091 61.976 85 64.1851 85H74.6771C76.8862 85 78.6771 83.2091 78.6771 81Z" fill="#C1C1C1" />
    </svg>
  );
}
